import React from 'react';

import { usePostOfficePlacement } from '@atlassian/conversation-assistant-utils/usePostOfficePlacement';

export const RemoteRovoChatSourcesPostOfficePlacement = (): React.JSX.Element | null => {
	const { PostOfficePlacement, isMounted } = usePostOfficePlacement();

	if (!isMounted || !PostOfficePlacement) {
		return null;
	}

	return <PostOfficePlacement placementId="rovo-chat-sources" />;
};
